import { Enumeration } from './Enumeration';

class CommissionModelEnum extends Enumeration {
  // Values match the string names returned by the API (JsonStringEnumConverter convention)
  AssurandorIIF = 'AssurandorIIF';
  ExternalSalesDK = 'ExternalSalesDK';

  constructor() {
    super();
    return Object.freeze(this);
  }
}

export const CommissionModel = new CommissionModelEnum();
